import RespinRecord from "model/respin-record";
import { SpinRecordBuilder } from "quickfire/integration/builders/record/spin-record-builder";
import { symbolsName } from "sg-consts";
import Gameplay from "slotworks/model/gameplay/gameplay";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import { ExpansionResult } from "slotworks/model/gameplay/records/results/expansion-result";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import slotDefinition from "slotworks/model/slot-definition";
import { asArray } from "slotworks/utils/collection-utils";
import Point from "slotworks/utils/geom/point";
import sgRespinGuaranteeResultBuilder from "../result/sg-respin-guarantee-result-builder";

class SGSpinRecordBuilder extends SpinRecordBuilder {
    public build(gameplay: Gameplay, request: any, packet: QuickfireResponsePacket): SpinRecord[] {
        const slot: QuickfireResponse["Slot"] = packet.Response.Slot;
        const nextStage: string = slot.attributes.nextStage;

        const record: SpinRecord = super.build(gameplay, request, packet)[0];

        record.hasChildren =
            record.id === "RespinRecord" && nextStage === "free_spin_2" ||
            record.id === "SpinRecord" && nextStage !== "paid_spin";
        record.lastChild =
            record.id === "RespinRecord" && nextStage === "free_spin_2" ||
            parseInt(slot.attributes.freeSpins) === 0;

        this.addRespinGuaranteeResults(record, packet);
        this.addExpansionResults(record, packet);

        return [record];
    }

    protected resolveRecordType(gameplay: Gameplay, request: any, packet: QuickfireResponsePacket): SpinRecord {
        const stage = packet.Response.Slot.attributes.stage.toLowerCase();
        switch (stage) {
            case "paid_spin":
                return new SpinRecord();
            case "free_spin_1":
                return new RespinRecord();
            case "free_spin_2":
                return new FreespinRecord();
            default:
                throw new Error(`Stage: ${stage} is not supported`);
        }
    }

    private addRespinGuaranteeResults(record: SpinRecord, packet: QuickfireResponsePacket): void {
        const tokens: QuickfireResponse["Tokens"] = packet.Response.Tokens;
        if (tokens && sgRespinGuaranteeResultBuilder.filter(record, tokens, packet)) {
            record.results.push(...sgRespinGuaranteeResultBuilder.build(record, tokens, packet));
        }
    }

    private addExpansionResults(record: SpinRecord, packet: QuickfireResponsePacket): void {
        if (packet.Response.Slot.StickyWilds && packet.Response.Slot.StickyWilds.StickyWild) {

            const qfStickyWilds: QuickfireStickyWild[] = asArray<QuickfireStickyWild>(packet.Response.Slot.StickyWilds.StickyWild);
            const stickyWildsByReel: QuickfireStickyWild[][] = [[], [], [], [], []];

            qfStickyWilds.forEach((qfStickyWild: QuickfireStickyWild) => {
                const reel: number = parseInt(qfStickyWild.attributes.index) % slotDefinition.matrixGrid.length;
                stickyWildsByReel[reel].push(qfStickyWild);
            });

            stickyWildsByReel.forEach((stickyWilds: QuickfireStickyWild[], reel) => {

                if (stickyWilds.length) {

                    const startPoint: Point = new Point(reel, record.grid[reel].indexOf(symbolsName.WILD));
                    const expansionPoints: Point[] = [];

                    stickyWilds.forEach((stickyWild: QuickfireStickyWild) => {
                        const row: number = Math.floor(parseInt(stickyWild.attributes.index) / slotDefinition.matrixGrid.length);
                        if (row !== startPoint.x) {
                            expansionPoints.push(new Point(reel, row));
                        }
                    });

                    record.results.push(new ExpansionResult(symbolsName.WILD, startPoint, expansionPoints));
                }
            });
        }
    }
}

export default new SGSpinRecordBuilder();
